import { render, staticRenderFns } from "./ItemInboxCard.vue?vue&type=template&id=4be8c082&scoped=true&lang=pug&"
import script from "./ItemInboxCard.vue?vue&type=script&lang=js&"
export * from "./ItemInboxCard.vue?vue&type=script&lang=js&"
import style0 from "./ItemInboxCard.vue?vue&type=style&index=0&id=4be8c082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be8c082",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
